//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import { RecycleScroller } from 'vue-virtual-scroller';
import { clearTextSelection } from '@/helpers/util';
import DpGridRow from './GridRow.vue';

export default {
  name: 'DpGridRows',
  components: {
    DpGridRow,
    RecycleScroller,
  },
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    settings: { type: Object, default: () => ({}) },
    selectable: { type: Boolean, default: false },
    selected: { type: Array, default: () => [] },
    kpi: { type: Object, default: null },
    historyMode: { type: Boolean, default: false },
    explicitKey: { type: String, default: null },
  },
  data() {
    return {
      selections: [],
      scrollArea: null,
      start: 0,
      anchorRow: null,
      anchorIndex: 0,
    };
  },
  computed: {
    keyField() {
      if (this.explicitKey) {
        return this.explicitKey;
      }
      if (this.historyMode) {
        return 'key';
      }
      return '$id';
    },
  },
  watch: {
    selected(newSelections) {
      this.selections = newSelections;
      this.navigateToSelection();
    },
    data() {
      this.navigateToSelection();
    },
  },
  mounted() {
    this.scrollArea = this.$el;
    this.selections = this.selected;

    this.navigateToSelection();
  },
  methods: {
    navigateToSelection() {
      if (this.selections.length > 0 && this.data) {
        // Work out the element index for the last selection
        const lastSelection = this.selections[this.selections.length - 1];
        let lastElementIndex = null;
        this.data.forEach((d, index) => {
          if (_.isEqual(d, lastSelection)) {
            lastElementIndex = index;
          }
        });

        if (lastElementIndex) {
          const { $_startIndex: start, $_endIndex: end } = this.$refs.virtualList;
          if (lastElementIndex > start && lastElementIndex < end) {
            return;
          }

          this.$refs.virtualList.scrollToItem(lastElementIndex);
        }
      }
    },
    clickRow(e, row, index) {
      if (!this.settings.selectEnabled) {
        return;
      }

      if (e.shiftKey) {
        clearTextSelection();
        setTimeout(() => this.selectMultiRow(row, index), 10);
      } else if (!e.metaKey && !e.ctrlKey) {
        this.selectSingleRow(row, index);
      } else {
        this.toggleSelection(row);
      }
    },
    selectSingleRow(row, index) {
      if (this.selections.length > 1 || !_.isEqual(this.selections[0], row)) {
        this.selections = [row];
        this.anchorRow = row;
        this.anchorIndex = index;
      } else {
        this.selections = [];
        this.anchorRow = null;
        this.anchorIndex = 0;
      }
      this.emitSelection();
    },
    selectMultiRow(row, index) {
      if (!this.anchorRow) {
        [this.anchorRow] = this.data;
        this.anchorIndex = 0;
      }

      let startAdding = false;
      let goingDown = true;
      if (index < this.anchorIndex) {
        goingDown = false;
      }

      this.selections = [];
      this.data.forEach((d) => {
        if ((!goingDown && row === d) || (goingDown && d === this.anchorRow)) {
          startAdding = true;
        }

        if (startAdding) {
          this.selections.push(d);
        }

        if ((!goingDown && d === this.anchorRow) || (goingDown && row === d)) {
          startAdding = false;
        }
      });
      this.emitSelection();
    },
    toggleSelection(row) {
      let found = false;
      this.selections.forEach((s, index) => {
        if (_.isEqual(s, row)) {
          found = true;
          this.selections.splice(index, 1);
        }
      });

      if (!found) {
        this.selections.push(row);
      }
      this.emitSelection();
    },
    emitSelection() {
      this.$emit('selection-changed', this.selections);
    },
  },
};
